<template>
  <v-data-table
    :headers="headers"
    :items="shops"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="Shop-button-new"
          @click="$router.push({
            name: 'suppliers-EditShop'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'suppliers-EditShop',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListShop',
  module: 'Suppliers',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('shops', ['shops']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('name'),
          value: 'name',
        },
        {
          text: this.$$t('bannerImageUrl'),
          value: 'bannerImageUrl',
        },
        {
          text: this.$$t('contactNumber'),
          value: 'contactNumber',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_shops();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('shops', ['LOAD_shops', 'DELETE_shop']),
    /** Delete Shop from the collection
     */
    async remove(shop) {
      this.isLoading = true;
      await this.DELETE_shop(shop.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# Shop example

'''js
<Shop />
'''
</docs>
